/**
 * Client-side multi-word, order-independent substring match.
 *
 * Splits `query` on whitespace and returns `true` when every token appears
 * somewhere in `text` (case-insensitive). Single-word queries fall back to a
 * simple `.includes()` check.
 */
export const multiWordMatch = (text: string, query: string): boolean => {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const lower = text.toLowerCase();
  return tokens.every((token) => lower.includes(token));
};
